import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        class: '=?',
        trigger: '=?',
        appendToBody: '=?',
        html: '=',
        label: '=?'
    },
    template: `
        <span
            class="{{ vm.class }}"
            tooltip-trigger="{{ vm.trigger }}"
            tooltip-append-to-body="{{ vm.appendToBody }}"
            uib-tooltip-html="'{{ vm.html }}'"
            ng-bind-html="vm.trustedLabel"
        ></span>
    `
})
export default class {
    constructor ($sce) {
        this.$sce = $sce;
    }

    $onInit () {
        this.class = this.class || 'tooltip-icon';
        this.trigger = this.trigger || 'outsideClick';
        this.appendToBody = this.appendToBody || true;
        this.label = this.label || '?';
        this.trustedLabel = this.$sce.trustAsHtml(this.label);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/tooltip/index.js